/* @flow weak */
import Button from 'components/Button.jsx';
import ConnectedBankAccountActions from 'payments/actions/ConnectedBankAccountActions';
import Field from 'components/Field.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import Label from 'components/Label.jsx';
import React from 'react';
import Textarea from 'components/Textarea.jsx';
import Text from 'components/Text.jsx';
import ToastActions from 'actions/ToastActions';
import FormSchoolPicker from 'components/FormSchoolPicker.jsx';
import { AddSchoolAccount } from '../constants/CopyConstants';

import './styles/AddSchoolAccountForm.scss';

export default React.createClass({
  propTypes: {
    onSchoolBankAccountAdded: React.PropTypes.func,
  },

  getInitialState() {
    return {
      loading: false,
    };
  },

  onInvalidSubmit() {
    ToastActions.showErrorToast(
      'Enter all required fields to continue.'
    );
  },

  onSubmit(form) {
    this.setState({ loading: true });
    const onDone = () => {
      if (this.isMounted()) {
        this.setState({ loading: false });
      }
    };
    const { adminEmail, adminName, adminNote, adminSchool } = form;

    ConnectedBankAccountActions.requestAccess(adminName, adminEmail, adminNote, adminSchool)
      .then(account => {
        if (this.props.onSchoolBankAccountAdded) {
          this.props.onSchoolBankAccountAdded(account);
        }
      }).then(onDone, () => {
        ToastActions.showDefaultErrorToast();
        onDone();
      });
  },

  render() {
    const noteDefault = AddSchoolAccount.defaultNote1 + ' ' + AddSchoolAccount.defaultNote2 + ' '
      + AddSchoolAccount.defaultNote3 + ' ' + AddSchoolAccount.defaultNote4 + ' '
      + AddSchoolAccount.defaultNote5;

    return (
      <div className="AddSchoolAccountForm">
        <Form
          className="AddSchoolAccountForm-form"
          onValidSubmit={this.onSubmit}
          onInvalidSubmit={this.onInvalidSubmit}>
          <div className="AddSchoolAccountForm-fields">
            <FormInput
              label="Account administrator’s name"
              autofocus
              autoComplete="off"
              name="adminName"
              required="isRequired"
              showErrorAfterBlur
              validationErrors={{
                isRequired: 'A full name is required',
              }}
            />
            <FormInput
              label="Account administrator’s email"
              name="adminEmail"
              autoComplete="off"
              required="isRequired"
              validations="isEmail"
              showErrorAfterBlur
              validationErrors={{
                isEmail: 'A valid email address is required',
                isRequired: 'An email address is required',
              }}
            />
            <Field>
              <Label text="School name" />
              <FormSchoolPicker
                className="AddSchoolAccountForm-schoolPicker"
                name="adminSchool"
                ref="schoolPicker"
                onNoSchool={() => {}}
              />
            </Field>
            <FormInput
              label="Note to account administrator"
              name="adminNote"
              autoComplete="off"
              component={Textarea}
              className="AddSchoolAccountForm-textarea"
              value={noteDefault}
              required="isRequired"
              placeholder="Why do you need access to deposit?"
              showErrorAfterBlur
              validationErrors={{
                isRequired: 'Must provide a reason for the deposit request',
              }}
            />
          </div>
          <div className="AddSchoolAccountForm-footer">
            <Button
              className="AddSchoolAccountForm-submit"
              loading={this.state.loading}
              eventElementName="AddSchoolAccountForm-submit">
              <Text size="xsmall">
                Continue
              </Text>
            </Button>
          </div>
        </Form>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/payments/components/AddSchoolAccountForm.jsx